const successContent = {
  thanks: 'Gracias por agendar tu cita, ya queremos verte!',
  addCalendar: 'Agregar a mi calendario',
  recommendations: 'Recomendaciones',
  seeMaps: 'Ver en maps'
}

export default successContent
